import DiscoveriesSection from './DiscoveriesSection';

export default DiscoveriesSection;
